export { Action, isType, actionCreatorFactory } from "diy/redux/typedActions";
export {default as StoreProvider} from "diy/redux/StoreProvider";

/**
 * Wrapper for Object.assign that returns a new object.
 * Type checks ensure only existing properties are overriden and no new
 * properties are added. It also checks (shallow) if overriden properties
 * are the same and returns the old object if so.
 */
export function objectOverride<T extends U, U>(first: T, override: U): T {
    // Optimization: when the override has identical values, return the old object
    if (typeof first === 'object' && typeof override === 'object') {
        let isDifferent = Object.keys(override).some(key => (<any>first)[key] !== (<any>override)[key]);
        if (!isDifferent) {
            return first;
        }
    }
    return Object.assign({}, first, override);
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/redux/helper.ts
 **/